import * as React from 'react';
import { styled } from '@mui/material/styles';
import { useTheme } from '@mui/material/styles';
import { darken, lighten, alpha, duration } from "@mui/material";
import Typography from "@mui/material/Typography";
import Checkbox from '@mui/material/Checkbox';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';

import Button from '@mui/material/Button';
import IconButton from '@mui/material/IconButton';

import Bs4Dialog from '../../Bs4Components/Bs4Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';

import Fab from '@mui/material/Fab';

import Stack from '@mui/material/Stack';
import Box from '@mui/material/Box';

import ButtonBase from '@mui/material/ButtonBase';
import Tooltip, {tooltipClasses} from '@mui/material/Tooltip';

import {   
  // TYPE_NAVIGATION,
  TYPE_CALENDAR,
  // TYPE_AGENDE,
  // TYPE_SCHEDULER,
  TYPE_MODIFIER,

  VIEW_TYPE_YEAR,
  VIEW_TYPE_MONTH,
  VIEW_TYPE_WEEK,
  VIEW_TYPE_DAY,
  VIEW_TYPE_AGENDE,

  VIEW_TYPE_MODIFIER_LAYER0,
  VIEW_TYPE_MODIFIER_LAYER1,
  VIEW_TYPE_MODIFIER_HOURS_MIN_MAX,

  footerButtons,
  isSelected,
} from './Bs4ReportCalendarConst';

import Bs4ReportCalendarView from './Bs4ReportCalendarView';
import Bs4ReportCalendarViewYear from './Bs4ReportCalendarViewYear';
import Bs4ReportCalendarViewMonth from './Bs4ReportCalendarViewMonth';
import Bs4ReportCalendarViewDays from './Bs4ReportCalendarViewDays';
import Bs4ReportCalendarViewList from './Bs4ReportCalendarViewList';

import Bs4ReportViewFooter from '../Bs4ReportViewFooter';
import CircularProgress from '@mui/material/CircularProgress';

import * as Bs4Utils from '../../Bs4Components/Bs4Utils'
import { EventEmit } from '../../Bs4Components/Bs4Utils'
import { getBoxSx, getBoxStyle } from '../../Bs4Theme/Bs4UxTemplates';
import { SmallScreenContext, useStateUxTemplate } from '../../Bs4Theme/Bs4UxTemplates';

import { DndContext, useDroppable, DragOverlay } from '@dnd-kit/core';
import { KeyboardSensor, MouseSensor, PointerSensor, TouchSensor, useSensor, useSensors } from '@dnd-kit/core';
import { v4 as uuidv4 } from 'uuid';

import {  
  add,
  addSeconds,
  addMinutes,
  addHours, startOfHour, endOfHour,
  addDays, startOfDay, endOfDay,
  addWeeks, startOfWeek, endOfWeek,  
  addMonths, startOfMonth, endOfMonth,
  addYears, startOfYear, endOfYear,
  subMilliseconds,
  compareAsc, compareDesc,
  eachHourOfInterval, eachDayOfInterval, eachWeekOfInterval, eachWeekendOfInterval, eachMonthOfInterval, eachYearOfInterval,
  format,
  // areIntervalsOverlapping,
  getDaysInMonth,
  differenceInMilliseconds, differenceInMinutes, differenceInDays,
  addMilliseconds,
  max, min,
  getWeek,
  differenceInCalendarYears, differenceInCalendarMonths, differenceInCalendarDays, differenceInCalendarWeeks, differenceInHours,
  roundToNearestMinutes,
  setMilliseconds, setSeconds, setMinutes, setHours,
  getMilliseconds, getSeconds, getMinutes, getHours,
} from "date-fns";

import { ViewBs4EventEl, ViewBs4EventDragOverlay, ORIENTATION_LIST } from './Bs4ReportCalendarViewBs4Event';

const TYPE_BS4REPORT = 'type_Bs4Reporttype42';
const NAME_BS4REPORT = 'Bs4Report42';
const DROPPABLE = 'droppable';
export const RESOURCES_CHANGE = 'resourcesChange';

export default class Bs4ReportCalendar {

  constructor(initialValues, viewButtons) {
    this.initialValues = initialValues;
    this.viewButtons = viewButtons;
    this.bs4Calendar.allowaddevent = this.initialValues.allowaddevent;
    this.bs4Calendar.nearestTo = this.initialValues.minInterval;
    this.bs4Calendar.viewType = this.initialValues.viewType;
    const hoursMinSec = parseInt(this.initialValues.hoursMinSec);
    const hoursMaxSec = parseInt(this.initialValues.hoursMaxSec);
    this.bs4Calendar.hoursMinSec = Bs4Utils.isNullOrNaN(hoursMinSec) ? null : Math.floor(hoursMinSec / 3600.0) * 3600;
    this.bs4Calendar.hoursMaxSec = Bs4Utils.isNullOrNaN(hoursMaxSec) ? null : Math.ceil(hoursMaxSec / 3600.0) * 3600;
    this.eventEmit = new EventEmit(); 
  }
  
  reload = () => {
    console.log('...Bs4ReportCalendar...reload...');
    this.resetColumnsMenu();
    this.loadData();
  }

  ScrollContext = React.createContext({});

  bs4Calendar = {
    viewType: VIEW_TYPE_WEEK,
    modifierAgende: false,
    hoursMinMax: true,
    layer0: true,
    layer1: true,
    date: new Date(),
    start: null,    
    end: null,
    startData: null,
    endData: null,
    resources: {},
    bs4EventArray: [],
    columnsMenu: [],
    nearestTo: 5,
    allowaddevent: false,
    hoursMinSec: null,
    hoursMaxSec: null,

    roundTo: function(date) {
      return roundToNearestMinutes(date, {nearestTo: this.nearestTo});
    },

    getVisibleEvents: function() {
      return this.bs4EventArray.filter(bs4Event => {
        const resource = this.resources[bs4Event.ResourceId];
        if (!resource) {
          // console.log('...No resource forr:', bs4Event);
        };
        return !resource?.disabled;
      });
    },
  
    getCalendarView: function() {
      this.updateScope();
      switch (this.viewType) {
        case VIEW_TYPE_YEAR: return new Bs4ReportCalendarViewYear();
        case VIEW_TYPE_MONTH: return new Bs4ReportCalendarViewMonth();
        case VIEW_TYPE_WEEK: return new Bs4ReportCalendarViewDays();
        case VIEW_TYPE_DAY: return new Bs4ReportCalendarViewDays();
        case VIEW_TYPE_AGENDE: return new Bs4ReportCalendarViewList();
        default: return new Bs4ReportCalendarView();
      }
    },

    updateScope: function() {
      this.headers = [];      
      switch (this.viewType) {
        case VIEW_TYPE_YEAR:          
          this.start = startOfYear(this.date);
          this.start = startOfWeek(this.start);
          this.end = endOfYear(this.date);
          this.end = endOfWeek(this.end);
          break;

        case VIEW_TYPE_MONTH:
          this.start = startOfMonth(this.date);
          this.start = startOfWeek(this.start);
          this.end = endOfMonth(this.date);
          this.end = endOfWeek(this.end);
          break;
  
        case VIEW_TYPE_WEEK:
          this.start = startOfWeek(this.date);
          this.end = endOfWeek(this.date);
          break;
      
        case VIEW_TYPE_DAY:        
          this.start = startOfDay(this.date);
          this.end = endOfDay(this.date);
          break;
          
        case VIEW_TYPE_AGENDE:        
          this.start = startOfDay(this.date);
          //this.end = addDays(this.start, 31);
          this.end = addMonths(this.start, 1);
          break;

        default:          
          break;
      }    
    },

    getStartVisibleDay: function(date) {
      if (!this.hoursMinMax || (this.viewType !== VIEW_TYPE_WEEK && this.viewType !== VIEW_TYPE_DAY) || Bs4Utils.isNullOrNaN(this.hoursMinSec)) return startOfDay(date);
      return addSeconds(startOfDay(date), this.hoursMinSec)
    },

    getEndVisibleDay: function(date) {
      if (!this.hoursMinMax || (this.viewType !== VIEW_TYPE_WEEK && this.viewType !== VIEW_TYPE_DAY) || Bs4Utils.isNullOrNaN(this.hoursMaxSec)) return endOfDay(date);
      return subMilliseconds(addSeconds(startOfDay(date), this.hoursMaxSec), 1);
    },

    updateRelative: function(n) {
      switch (this.viewType) {
        case VIEW_TYPE_YEAR:
          this.date = addYears(this.date, n);
          break;
  
        case VIEW_TYPE_MONTH:        
          this.date = addMonths(this.date, n);
          break;
  
        case VIEW_TYPE_WEEK:
          this.date = addWeeks(this.date, n);
          break;

        case VIEW_TYPE_AGENDE:
          this.date = addMonths(this.date, n);
          //this.date = addDays(this.date, n * 31);
          break;

        case VIEW_TYPE_DAY:
        default:
          this.date = addDays(this.date, n);
          break;
      }
    },

    updateRelativeParent: function(n) {
      switch (this.viewType) {
        case VIEW_TYPE_YEAR:
          // Nie powinno wystąpić (nie ma widoku wieku ani ery)
          // this.date = addYears(this.date, 100 * n);
          break;
  
        case VIEW_TYPE_MONTH:        
          this.date = addYears(this.date, n);
          break;
  
        case VIEW_TYPE_WEEK:
          this.date = addMonths(this.date, n);
          break;
  
        case VIEW_TYPE_AGENDE:
          this.date = addYears(this.date, n);
          break;

        case VIEW_TYPE_DAY:
        default:
          this.date = addWeeks(this.date, n);
          break;
      }
    },    
  }

  updateScope = () => {
    this.bs4Calendar.updateScope();    
    if (!this.bs4Calendar.startData || !this.bs4Calendar.endData || 
      compareAsc(this.bs4Calendar.startData, this.bs4Calendar.start) > 0 || 
      compareAsc(this.bs4Calendar.end, this.bs4Calendar.endData) > 0) {    
      this.loadData();
    } else {
      this.eventEmit.trigger(RESOURCES_CHANGE, null);
    }    
  }

  changeView = (date, viewType) => {    
    this.bs4Calendar.date = date;
    this.bs4Calendar.viewType = viewType;
    // console.log('...Bs4ReportCalendar...changeView...', Bs4Utils.toDate(this.bs4Calendar.date), this.bs4Calendar.viewType)
    this.updateScope();
  }

  setDisplayWait = (wait) => {}

  loadData = () => {
    const successCallback = (newResource, newEvents) => {
      this.bs4Calendar.startData = this.bs4Calendar.start;
      this.bs4Calendar.endData = this.bs4Calendar.end;
      this.bs4Calendar.resources = this.getResources(newResource, this.bs4Calendar.resources);
      this.bs4Calendar.bs4EventArray = this.getEvents(newEvents);      
      // console.log('...???...Bs4ReportCalendar...loadData...', this.bs4Calendar)
      this.updateScope();
      this.setDisplayWait(false);      
    };

    const failureCallback = (error) => {
      console.log('===Bs4ReportTimeline ERROR fetchMore', error);
      this.setDisplayWait(false);
    };
    
    this.setDisplayWait(true);
    if (this.fetchMore) this.fetchMore(this.bs4Calendar, successCallback, failureCallback)
  }

  getBs4Event = (bs4Event) => {
    bs4Event.key = uuidv4();
    bs4Event.start = new Date(bs4Event.StartDate);
    bs4Event.end = new Date(bs4Event.EndDate);
    bs4Event.duration = differenceInMilliseconds(bs4Event.end, bs4Event.start);
    bs4Event.layer = Boolean(parseInt(bs4Event.layer) === 1);
    // chtime - tylko do opcji    
    // chaxis - blokuje przeciąganie do opcji
    // Jeżeli xxxx jest jawnie zabronione (parseInt(bs4Event.xxxx) !== 1), to jezt zabronone.
    // Jeżeli xxxx jest jawnie dozwolone (parseInt(bs4Event.xxxx) === 1), to jezt dozwolone.
    // Jeżeli xxxx nie jest jawnie zabronione (!bs4Event.hasOwnProperty.xxxx), to jest dozwolone. 
    bs4Event.chtime = Boolean(parseInt(bs4Event.chtime) === 1);
    bs4Event.chaxis = Boolean(this.bs4Calendar.columnsMenu.length > 0); //Boolean(parseInt(bs4Event.chaxis) === 1);
    return bs4Event;
  }

  getResources = (newResources, oldResources) => {    
    // const resourcesSorted = (Array.isArray(newResource) ? newResource : []).sort((a, b) => a.Ordered - b.Ordered);
    const resources = (Array.isArray(newResources) ? newResources : []).reduce((resources, resource) => {
      resource.disabled = oldResources[resource.Id]?.disabled || false;
      resources[resource.Id] = resource;
      return resources;
    }, {}) 
    return resources;
  }

  getEvents = (newEvents) => {    
    const events = (Array.isArray(newEvents) ? newEvents : []).map(event => this.getBs4Event(event));
    return events;
  }

  ViewResources = (props) => {
    const report = this;
    const theme = useTheme();
    const [open, setOpen] = React.useState(false);    
    const refHeader = React.useRef(null);
    const {dateTimeStamp} = useStateUxTemplate(TYPE_BS4REPORT);
    const [calendarChangeTime, setCalendarChangeTime] = React.useState(new Date());

    const boxSx = React.useMemo(() => {
      return {        
        ...getBoxSx(this.uxTemplate?.body?.Report42?.resources.box, theme),
      }
    }, [dateTimeStamp, theme]);

    const handleOpen = () => {
      setOpen(true);
    };

    const handleClose = () => {
      setOpen(false);
    };

    const onChangeCalendar = (event, resource) => {
      this.bs4Calendar.resources[resource.Id].disabled = !Boolean(event?.target?.checked);
      this.eventEmit.trigger(RESOURCES_CHANGE, null);
    }
    
    React.useEffect(() => {
      this.eventEmit.on(RESOURCES_CHANGE, () => {setCalendarChangeTime(new Date());});
    }, [setCalendarChangeTime]);
    
    if (Object.values(this.bs4Calendar.resources).length < 2) return null;

    return (
      <React.Fragment>
        <IconButton onClick={handleOpen}>
          <i className="fa-solid fa-filter-list"></i>
        </IconButton>
        <Bs4Dialog
          open={open}
          bs4KartotekaId={report.bs4KartotekaId}
          TransitionComponent={this.TransitionColumns}
          //keepMounted
          onClose={handleClose}
          refHeader={refHeader}
          hideBackdrop={true}
          PaperProps={{sx: boxSx}}          
        >
          <DialogTitle ref={refHeader} sx={{touchAction: 'none'}}>
            <Stack width='100%' direction='row' justifyContent="space-between" sx={{cursor:'move'}}>
              <span><i className="fa-solid fa-filter-list"/>&nbsp;&nbsp;{'Kalendarze'}</span>              
            </Stack>
          </DialogTitle>
          <DialogContent>
            <List sx={{overflow:'auto'}}> 
              {Object.values(this.bs4Calendar.resources).map(resource => {
                return (
                  <ListItem
                    key={resource.Id}
                    secondaryAction={
                    <Checkbox
                      edge="end"
                      onChange={(event) => onChangeCalendar(event, resource)}
                      checked={!resource.disabled}
                    />
                    }
                    //disablePadding
                  >
                    {resource.Name}
                  </ListItem>
                )
              })}
            </List>
          </DialogContent>
          <DialogActions>
            <Button onClick={handleClose}>{'Ok'}</Button>
          </DialogActions>
        </Bs4Dialog>        
      </React.Fragment>
    )
  }

  ViewFooter = (props) => {
    const report = this;

    const [footerButtonsCALENDAR, footerButtonsMODIFIER] = React.useMemo(() => {
      const footerButtonsCALENDAR = footerButtons.filter(view => isSelected(props.viewButtons ,view, TYPE_CALENDAR));
      const footerButtonsMODIFIER = footerButtons.filter(view => isSelected(props.viewButtons ,view, TYPE_MODIFIER));
      if (!footerButtonsCALENDAR.find(view => view.viewType === this.bs4Calendar.viewType)) {
        this.bs4Calendar.viewType = footerButtonsCALENDAR[0]?.viewType || VIEW_TYPE_MONTH;
      }
      return [footerButtonsCALENDAR, footerButtonsMODIFIER]      
    }, [props.viewButtons])
    
    const [modifiers, setModifiers] = React.useState([]);          

    const handleViewType = (e, viewType) => {
      this.bs4Calendar.viewType = viewType;
      // console.log('...Bs4ReportCalendar...changeView.1.', Bs4Utils.toDate(this.bs4Calendar.date), this.bs4Calendar.viewType)
      this.updateScope();
    }

    const handleSettings = React.useCallback((e, modifiers) => {
      setModifiers(modifiers);
      this.bs4Calendar.layer0 = modifiers.includes(VIEW_TYPE_MODIFIER_LAYER0);
      this.bs4Calendar.layer1 = modifiers.includes(VIEW_TYPE_MODIFIER_LAYER1);
      this.bs4Calendar.hoursMinMax = modifiers.includes(VIEW_TYPE_MODIFIER_HOURS_MIN_MAX);
      this.updateScope();        
    }, [setModifiers]);
  
    const handleNavigationPreviousParentPeriod = (e) => {
      this.bs4Calendar.updateRelativeParent(-1);      
      this.updateScope();
    }

    const handleNavigationPreviousPeriod = (e) => {
      this.bs4Calendar.updateRelative(-1);
      this.updateScope();
    }

    const handleNavigationNextPeriod = (e) => {
      this.bs4Calendar.updateRelative(1);
      this.updateScope();
    }

    const handleNavigationNextParentPeriod = (e) => {
      this.bs4Calendar.updateRelativeParent(1);      
      this.updateScope();
    }

    const handleDateChange = (newValue) => {      
      this.bs4Calendar.date = newValue;
      this.updateScope();
    }

    React.useEffect(() => {
      handleSettings(null, props.modifiers);
    }, [handleSettings, props.modifiers])

    return (
      <Bs4ReportViewFooter
        footerButtons={footerButtonsCALENDAR}        
        viewType={report.bs4Calendar.viewType}
        exact={!report.bs4Calendar.adjustmentToUnitWidth}
        footerButtonsModifier={footerButtonsMODIFIER}
        modifiers={modifiers}
        onChangeViewType={handleViewType}
        onChangeSettings={handleSettings}

        sx={props.sx}
        slotProps={{
          navigation: {
            date: report.bs4Calendar.date || new Date(),
            moveYear: this.bs4Calendar.viewType !== VIEW_TYPE_YEAR,
            previousYear: handleNavigationPreviousParentPeriod,
            previousPeriod: handleNavigationPreviousPeriod,
            nextPeriod: handleNavigationNextPeriod,
            nextYear: handleNavigationNextParentPeriod,     
            onDataChange: handleDateChange,
          },
          reportIcon: {
            sx: {flex: 0},
            onShow: props.onShow,
            onRemember: props.onRemember,
            onReset: props.onReset,
          }
        }}
      />
    )
  }

  ViewOption = React.memo((props) => {
    const report = this;
    const theme = useTheme();
    const [bs4EventArray, setBs4EventArray] = React.useState([]);

    const setBs4ActiveMove = React.useCallback((active, over, propsEnd) => {
      const bs4Event = active.props.el.bs4Event;
      if (!bs4Event.chaxis) return;
      if (bs4Event.move?.cursor) return;

      const el = {
        bs4Event: bs4Event,
        start: bs4Event.start,
        end: bs4Event.end,        
      };

      if (over) {
        setBs4EventArray([...bs4EventArray.filter(el => el.bs4Event.key != bs4Event.key), el]);
      } else {
        setBs4EventArray(bs4EventArray.filter(el => el.bs4Event.key != bs4Event.key));
        if (propsEnd) {
          props.onMenuClick && props.onMenuClick(props.menuItem.menuItem, bs4Event);
        }
      }    
    }, [bs4EventArray, setBs4EventArray, props.onMenuClick]);

    const [droppableRef, setDroppableRef] = React.useState({})

    const {isOver, active, setNodeRef, node} = useDroppable({
      id: DROPPABLE+'_option_menu_'+props.menuItem.index,
      data: {        
        setBs4ActiveMove: setBs4ActiveMove,
        droppableRef: droppableRef,
      }
    });    

    const boxSx = React.useMemo(() => {
      return {
        backgroundColor: lighten(theme.palette.primary.main, 0.8),
        color: theme.palette.text.primary,
        ...getBoxSx(props.uxBodyOption, theme),
        ...getBoxSx(props.menuItem?.style, theme),
        flex: 1,
      }
    }, [theme, props.uxBodyOption, props.menuItem?.style]);

    return (
      <Box 
        ref={setNodeRef} 
        sx={boxSx}
      >
        <Box>{props.menuItem.title}</Box>
        <Stack direction="column" spacing={0.5} sx={{justifyContent: "flex-start", alignItems: "flex-start", maxHeight: '350px', overflow: 'auto', paddingRight: 1}}>
          {bs4EventArray.map(el => {
            return (
              <ViewBs4EventEl
                key={el.bs4Event.id} 
                orientation={ORIENTATION_LIST}
                el={el} 
                uxBodyEvent={props.uxBodyEvent}
                onRowClick={props.onRowClick}
              />        
            )
          })}        
        </Stack>        
      </Box>
    )
  });

  resetColumnsMenu = () => {
    console.log('=== Error === resetColumnsMenu not implemented');
  }

  ViewOptions = (props) => {
    const report = this;    
    const [columnsMenu, setColumnsMenu] = React.useState([]);
    // console.log('...ViewOptions...', columnsMenu, props)

    React.useEffect(() => {
      this.resetColumnsMenu = () => {
        this.bs4Calendar.columnsMenu = (props.columnsMenu || []).map(menuItem => {
          return menuItem;
        })
        setColumnsMenu();
      }

      this.resetColumnsMenu();
    }, [props.columnsMenu, setColumnsMenu])

    return (
      <Box width='100%' display='flex' flexDirection='row' flexWrap='wrap' gap={2} p={props.columnsMenu?.length > 0 ? 2 : 0}>
        {report.bs4Calendar.columnsMenu?.map((menuItem) => {
          if (!Array.isArray(menuItem.events)) menuItem.events = [];
          return (
            <report.ViewOption
              key={menuItem.index}
              menuItem={menuItem}
              uxBodyOption={props.uxBodyOption}
              uxBodyEvent={props.uxBodyEvent}
              onMenuClick={props.onMenuClick}
              onRowClick={props.onRowClick}
            />
          )
        })}
      </Box>
    )
  }

  customCollisionDetectionAlgorithm = (props) => {
    const {droppableContainers, droppableRects, ...args} = props

    const collisions = [];    
    for (const droppableContainer of droppableContainers) {
      const {id} = droppableContainer;
      const rect = droppableContainer.node.current.getBoundingClientRect();
      const pointerCoordinates = props.pointerCoordinates;      
      if (rect) {
        let v = 9999;
        if (rect.left <= pointerCoordinates.x && rect.top <= pointerCoordinates.y && rect.right >= pointerCoordinates.x && rect.bottom >= pointerCoordinates.y) {
          v = 0;
        }

        droppableContainer.data.current.droppableRef.isIn = Boolean(v === 0);
        droppableContainer.data.current.droppableRef.pointerCoordinates = pointerCoordinates;
        collisions.push({id, data: {droppableContainer, value: v}});        
      }
    }

    const sortedCollisions  = collisions.sort(({data: {value: a}}, {data: {value: b}}) => a - b);    
    return sortedCollisions;
  };

  scrollMargin = 5;

  ViewComponent = React.forwardRef((props, ref) => {
    const report = this;
    const [calendarChangeTime, setCalendarChangeTime] = React.useState(new Date());
    const [activeChangeTime, setActiveChangeTime] = React.useState(new Date());

    const modifiers = React.useMemo(() => {
      return [VIEW_TYPE_MODIFIER_HOURS_MIN_MAX];
    }, [props.viewButtons])

    const [active, setActive] = React.useState(null);

    const [displayWait, setDisplayWait] = React.useState(false);    

    const view = React.useMemo(() => {
      const view = this.bs4Calendar.getCalendarView();
      view.bs4KartotekaId = this.bs4KartotekaId
      return view;
    }, [this.bs4Calendar.viewType, this.bs4Calendar.modifierAgende]);

    const sensors1 = useSensors(
      useSensor(KeyboardSensor),
      useSensor(MouseSensor),
      useSensor(TouchSensor),
    );

    const sensors = useSensors(
      useSensor(KeyboardSensor),
      useSensor(PointerSensor, {
        activationConstraint: {
          distance: 10,
          delay: 300,
          tolerance: 15,
        },
      }),
      // useSensor(TouchSensor, {
      //   // Press delay of 250ms, with tolerance of 5px of movement
      //   activationConstraint: {
      //     delay: 250,
      //     tolerance: 5,
      //   },
      // }),
    );

    React.useEffect(() => {
      this.eventEmit.on(RESOURCES_CHANGE, () => {
        setCalendarChangeTime(new Date());
      });
    }, [setCalendarChangeTime]);

    React.useEffect(() => {
      this.fetchMore = props.fetchMore;      
    }, [props.fetchMore]);    

    React.useEffect(() => {

    }, [props.initialView])

    React.useEffect(() => {
      this.updateScope();
      this.setDisplayWait = setDisplayWait;
    }, [this.updateScope, setDisplayWait]);        

    const handleDragStart = (event) => {      
      const draggableProps = event.active.data.current;
      // console.log('...handleDragStart...', event, {...draggableProps})
      draggableProps.setActive(true);
      setActive(draggableProps);
      setCalendarChangeTime(new Date);
      setActiveChangeTime(new Date);
      if (navigator.vibrate) navigator.vibrate(30);
    }    

    const handleDragMove = (event) => {            
      if (!active) {
        console.log('...handleDragMove...!active', )
        return;
      }

      if (active.setBs4ActiveMove) active.setBs4ActiveMove(active, null);
      if (active && event.over?.data?.current?.droppableRef?.isIn) {        
        active.setBs4ActiveMove = event.over?.data?.current?.setBs4ActiveMove;
        active.setBs4ActiveMove(active, event.over);
      } else {
        active.setBs4ActiveMove = null;        
      }
      setActiveChangeTime(new Date);
    }

    const handleDragEnd = (event) => { 
      if (!active?.setBs4ActiveMove) {
        handleDragCancel();
        return;
      }
      active.setActive(false);
      // console.log('...handleDragEnd...', event, {active});
      active.setBs4ActiveMove(active, null, props);
      active.setActive(false);
      setActive(null);
      setCalendarChangeTime(new Date);
      setActiveChangeTime(new Date);      
    }

    const handleDragCancel = (event) => {
      // console.log('...handleDragCancel...', {...active});
      if (active.props) {
        active.props.el.bs4Event.start = active.props.el.bs4Event.move.start;
        active.props.el.bs4Event.end = active.props.el.bs4Event.move.end;
        active.props.el.bs4Event.duration = active.props.el.bs4Event.move.duration;
      } else {
        console.log('...handleDragCancel...ERROR', active);
      }
      if (active.setBs4ActiveMove) active.setBs4ActiveMove(active, null);
      active.setActive(false);
      setActive(null);
      setCalendarChangeTime(new Date);
      setActiveChangeTime(new Date);      
    }    

    const handleClickAdd = (event) => {
      const now = new Date();      
      let start = this.bs4Calendar.date;
      start = setHours(start, getHours(now));
      start = setMinutes(start, getMinutes(now));
      start = this.bs4Calendar.roundTo(start);
      const end = addMinutes(start, this.bs4Calendar.nearestTo || 5);
      const newBs4Event = {
        Name: 'New bs4Event',
        start, 
        end,
        chtime: true,
      }      
      props.bs4EventAdd(newBs4Event);
    }

    return (
      <Box 
        sx={{
          position: 'relative',
          flex: 1,
          display: 'flex',
          flexDirection: 'column',
          overflow: 'hidden',
        }}
      >              
        <DndContext 
          onDragStart={handleDragStart}         
          onDragEnd={handleDragEnd}          
          onDragCancel={handleDragCancel}
          onDragMove={handleDragMove}
          sensors={sensors}
          collisionDetection={report.customCollisionDetectionAlgorithm}
        >        
          <Box
            sx={{
              position: 'relative', 
              flex: 1,
              overflow: 'hidden',
            }}            
          >
            <view.ViewComponent                                     
              //uxBodyEvent={props.uxBodyEvent}
              onRowClick={props.onRowClick}
              onChangeView={report.changeView}            
              bs4Calendar={report.bs4Calendar}
              calendarChangeTime={calendarChangeTime}
              activeChangeTime={activeChangeTime}
              setActive={setActive}
              active={active}
              setActiveChangeTime={setActiveChangeTime}
              bs4EventAdd={props.bs4EventAdd}
              setScrollTarget={props.setScrollTarget}
            />   
            <Fab 
              size='small' 
              color='primary' 
              onClick={handleClickAdd}
              sx={{
                display: this.bs4Calendar.allowaddevent ? null : 'none',
                position: 'absolute', 
                bottom: 10, 
                right: 10, 
              }}
            >
              {/* <i className="fa-regular fa-plus"></i> */}
              <i className="fa-solid fa-plus"></i>
            </Fab>
          </Box>       
          <report.ViewFooter
            uxBodyFooter={props.uxBodyFooter}
            onShow={props.onShow}
            onRemember={props.onRemember}
            onReset={props.onReset}
            viewButtons={report.viewButtons}
            modifiers={modifiers}
          />
          <report.ViewOptions 
            columnsMenu={props.columnsMenu}
            onMenuClick={props.onMenuClick}
            uxBodyOption={props.uxBodyOption}
            uxBodyEvent={props.uxBodyEvent}
            onRowClick={props.onRowClick}
          />
          {/* <DragOverlay> {active ? <ViewBs4EventDragOverlay {...active.props}/> : null} </DragOverlay> */}
          {active ? <ViewBs4EventDragOverlay {...active.props}/> : null} 
        </DndContext>        
        <Stack
          sx={{
            display: displayWait ? null : 'none', 
            position: 'absolute', 
            top: 0, 
            right: 0, 
            bottom: 0, 
            left: 0,
            backgroundColor: '#00000022',
            zIndex: 100,
          }}
          direction="row"
          justifyContent="center"
          alignItems="center"
          spacing={2}          
        >
          <CircularProgress/>
        </Stack>
      </Box>
    );        
  });
}